/* ============================================================
   AK Editorial Grid — last-row orphan centring

   Centres a lone card in the last row of a 2-column desktop grid.
   Done in JS (not Liquid) because the grid's real item count can
   change after render: a Letters cell may collapse when it finds
   no qualifying review, and the facet filter re-renders the grid.
   We count only the VISIBLE grid children, so the centring is
   always based on what's actually laid out.

   Toggles the .is-orphan-centered class (styled in the section).
   ============================================================ */
(function () {
  if (window.__akEditorialOrphanInit) return;
  window.__akEditorialOrphanInit = true;

  function initSection(section) {
    var cols = parseInt(section.getAttribute('data-desktop-columns'), 10) || 0;
    var observer = null;
    var scheduled = false;

    function recompute() {
      scheduled = false;
      if (observer) observer.disconnect();

      var grid = section.querySelector('.collection-grid');
      if (grid) {
        var kids = Array.prototype.slice.call(grid.children);
        for (var i = 0; i < kids.length; i++) kids[i].classList.remove('is-orphan-centered');

        // Only 2-column desktop needs an orphan centred; mobile (1 col)
        // and other counts never leave a single centred card.
        if (cols === 2 && window.matchMedia('(min-width: 990px)').matches) {
          var visible = kids.filter(function (k) {
            return window.getComputedStyle(k).display !== 'none';
          });
          // Full-width feature rows (ak-feature-row) split the grid into
          // runs of cards. Centre a lone last card in each run, so a card
          // left over before a feature row does not sit half-empty.
          var run = [];
          var flush = function () {
            if (run.length % 2 === 1) run[run.length - 1].classList.add('is-orphan-centered');
            run = [];
          };
          visible.forEach(function (k) {
            if (k.hasAttribute('data-ak-frow')) { flush(); } else { run.push(k); }
          });
          flush();
        }
      }

      if (observer) {
        observer.observe(section, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(recompute);
    }

    // Observe the stable section (survives the facet AJAX grid swap and
    // Letters-cell class changes). Disconnected during recompute so our
    // own class toggles don't retrigger it.
    try {
      observer = new MutationObserver(schedule);
    } catch (e) {}

    schedule();
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
  }

  function init() {
    var sections = document.querySelectorAll('[data-editorial-grid]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
